<template>
  <div class="progress-bar" role="progressbar" :aria-valuenow="aProgress" aria-valuemin="0" aria-valuemax="100" :style="{ opacity: routing && show ? 1 : 0 }">
    <div v-if="routing && show" class="progress" :style="{ width: `${aProgress}%` }"></div>
  </div>
</template>

<script>
import TWEEN from 'tween.js'
import { mapState } from 'vuex'

export default {
  name: 'progress-bar',
  data() {
    return {
      aProgress: 0,
      progress: 0,
      lastProgress: 0,
      show: false,
      tweens: []
    }
  },
  computed: {
    ...mapState({
      routing: state => state.ui.routing,
      total: state => state.progress.total,
      done: state => state.progress.done
    }),
  },
  methods: {
    updateProgress() {
      var vm = this;
      var config = { x: this.lastProgress };
      const time = (this.progress - this.lastProgress) * 10;
      this.lastProgress = this.progress;
      var tween = new TWEEN.Tween(config)
        .to({x: this.progress}, time)
        .onUpdate(() => {
          vm.aProgress = config.x;
          if (vm.aProgress == 100) {
            setTimeout(() => {
              vm.show = false;
            }, time)
          }
        })
        .onComplete(() => {
          vm.tweens = vm.tweens.slice(1, vm.tweens.length);
          if (vm.tweens.length > 0) {
            vm.tweens[0].start();
          }
        })

      this.tweens = this.tweens.concat([tween]);
      if (this.tweens.length == 1) {
        tween.start();
        animate();
      }

      function animate() {
        if (vm.aProgress != 100) requestAnimationFrame(animate);
        TWEEN.update();
      }
    }
  },
  watch: {
    routing() {
      if (this.routing) {
        this.show = true;
        this.aProgress = 10;
        this.progress = 10;
        this.lastProgress = 10;
      }
    },
    done() {
      this.progress = (this.done > this.total || this.total <= 0)
        ? 100 
        : (10 + this.done / this.total * 90);

      this.updateProgress();
    },
  }
}
</script>

<style lang="scss">
  .progress-bar {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    pointer-events: none;
    width: auto;
    height: 5px;
    background-color: rgba($color-midgrey, 0.9);
    transition: opacity 0.3s;
    z-index: 10005;
  }

  .progress {
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, $color-red 0%, #e11d48 50%, #f43f5e 100%);
    transform-origin: left;
    transition: width 0.1s;
    overflow: hidden;
    position: relative;
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255, 226, 226, 0.5) 50%,
        transparent 100%
      );
      animation: shimmer 2s infinite;
    }
  }

  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
</style>
